import React from "react";
import { Alert, Box } from "@mui/material";
import moment from "moment";

export function isPaymentDueSameAsFulfillment(dueDate, fulfillmentDate) {
  if (!dueDate || !fulfillmentDate) {
    return false;
  }
  return moment(dueDate, "YYYY-MM-DD").isSame(moment(fulfillmentDate, "YYYY-MM-DD"), "day");
}

export default function SameDayPaymentDueWarning({ dueDate, fulfillmentDate, customerType }) {
  if (customerType === "commercial") {
    return null;
  }
  if (!isPaymentDueSameAsFulfillment(dueDate, fulfillmentDate)) {
    return null;
  }

  return (
    <Box mt={2}>
      <Alert severity="warning">
        BakeStreet will not auto-charge the balance payment for this order since the payment due
        date is the same as the fulfillment date. Be sure to collect balance payment during
        pickup/delivery.
      </Alert>
    </Box>
  );
}
